import { TaasStatus } from '@ps20/bff-models';
import {
  BasisStreckenState,
  GlobalAction,
  GlobalActions,
  GlobalPut,
  ModalCloseReason,
  ModalType,
} from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { call, delay, put, select, take } from 'redux-saga/effects';
import { CallEffect, PutEffect, SelectEffect } from '@redux-saga/core/effects'; // NOSONAR
import { showTaasStatusModal, taasReturnStatus } from './errorHandlingTarifierung';

export function* handleTarifierungsReturnCodeInStrecke(
  taasStatus: TaasStatus,
  retryTarifierungAction: GlobalAction<unknown>,
  app: App,
  angebotsId?: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): any {
  const globalPut = GlobalPut.getInstance();
  const modalTypeForTaasStatus =
    taasStatus && taasStatus.returnCodeTaas && taasReturnStatus(taasStatus.returnCodeTaas);
  if (modalTypeForTaasStatus) {
    yield call(showTaasStatusModal, taasStatus, app, angebotsId);
    const closeModalAction = yield take(GlobalActions.CLOSE_MODAL);
    yield call(
      handleTarifierungModal,
      modalTypeForTaasStatus,
      closeModalAction.payload,
      retryTarifierungAction,
      app,
    );
  } else {
    yield call(
      globalPut.put,
      new GlobalActions().requestModal(ModalType.TARIFIERUNG_STRECKE_ERROR),
    );
    yield take(GlobalActions.CLOSE_MODAL);
    yield call(navigateToDashboardFromStrecke, app);
  }

  yield call(globalPut.put, new GlobalActions().tarifierungHasEnded());
}

function* handleTarifierungModal(
  modalType: ModalType,
  closeReason: ModalCloseReason,
  retryTarifierungAction: { type: string },
  app: App,
): Generator<CallEffect | PutEffect> {
  if (modalType === ModalType.TAAS_FEHLER_MIT_RETRY && closeReason === ModalCloseReason.PRIMARY) {
    return yield put(retryTarifierungAction);
  }
  return yield call(navigateToDashboardFromStrecke, app);
}

export function* navigateToDashboardFromStrecke(app: App): Generator<CallEffect | SelectEffect> {
  const globalPut = GlobalPut.getInstance();
  yield call(globalPut.put, new GlobalActions().navigationRequested({ appId: App.SHOP_DASHBOARD }));
  yield delay(0);
  const state: BasisStreckenState = (yield select()) as BasisStreckenState;
  yield call(globalPut.put, new GlobalActions().restoreStreckeSnapshot(app, state.angebotsId));
}
